import PropTypes from "prop-types";
import React from 'react';

function CardWrapper({
    children,
    customClass,
    customStyle,
}) {

    return (
        <div
            className={customClass}
            style={{
                borderRadius: "16px",
                display: "flex",
                width: "100%",                            
                ...customStyle
            }}
        >
           {children}
        </div>
    );
}

CardWrapper.defaultProps = {
    children: null,
    customStyle: null
};

CardWrapper.propTypes = {
    children: PropTypes.any,
    customStyle: PropTypes.object
};

export default CardWrapper;
